export const original = [
  {
    "pricefield": "Waterguard Smartstopp 3/4\" NO med 1 sensor",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Waterguard Smartstopp 1/2\" NO med 1 sensor",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "WATERGUARD SENSOR TRÅDLØS SMART SYSTEM",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Waterguard Remote interface",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Waterguard enkel",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Waterguard dobbel",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Waterguard BRL enkel ventil",
    "zone": "Vannstoppventil"
  },
  {
    "pricefield": "Watergard 1/2 enkel",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "VV bereder",
    "zone": "test"
  },
  {
    "pricefield": "Vintermatte 50 x 1200 x 3000 mm",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Vifte med fuktstyring",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Vifte med fuktstyring",
    "zone": "Generell"
  },
  {
    "pricefield": "Vifte med fuktstyring",
    "zone": "Baderom"
  },
  {
    "pricefield": "Veggskål Laufen pro",
    "zone": "Bad"
  },
  {
    "pricefield": "Veggbox 18mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Veggbox 15mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Veggbox 12mm",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Vaskemaskinkrane",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Varsling før oppstart ",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Varmekabel per kvm(limt på ubrennbart underlag)",
    "zone": "Varme"
  },
  {
    "pricefield": "Varmekabel per kvm",
    "zone": "Baderom"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Varme"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Stue"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Soverom"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Gang"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Bod"
  },
  {
    "pricefield": "Varmekabel (kvm) limt på ubrennbart underlag",
    "zone": "Baderom"
  },
  {
    "pricefield": "Varmefolie (per kvm)",
    "zone": "Varme"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Varme"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Stue"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Soverom"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Kontor"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Gang"
  },
  {
    "pricefield": "Varmefolie",
    "zone": "Bod"
  },
  {
    "pricefield": "Vanninntak etter TEK17 m/ekspansjon kar",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Utvendig stikkontakt IP44",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Utvendig stikkontakt IP44",
    "zone": "Stikk"
  },
  {
    "pricefield": "Utskifting av kabel fra koblingsboks til koblingsboks",
    "zone": "Stue"
  },
  {
    "pricefield": "Utskifting av eksisterende downlights",
    "zone": "Lys"
  },
  {
    "pricefield": "Utbytte sikring over 5stk",
    "zone": "Servise "
  },
  {
    "pricefield": "Utbytte sikring over 5stk",
    "zone": "Generelt "
  },
  {
    "pricefield": "Utarbeidelse av ny tegning basert på eksisterende",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Usb lader",
    "zone": "Stue"
  },
  {
    "pricefield": "Usb lader",
    "zone": "Stikk"
  },
  {
    "pricefield": "Usb lader",
    "zone": "Soverom"
  },
  {
    "pricefield": "Usb lader",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Underfordeling 1/rad påvegg (stål)",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Trykkslange 1/2\"V x 3/4\"V x 1200 mm ALTECH FLEXIBEL TRYKKSLANGE, DN 8",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Trykkprøving rør i rør",
    "zone": "Bad"
  },
  {
    "pricefield": "Trykkprøving av anlegg",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Trevi basic m/softclose",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Transport",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Timesats (for arbeid utenfor punktpriser)",
    "zone": "Generell"
  },
  {
    "pricefield": "Timesats",
    "zone": "Generelt"
  },
  {
    "pricefield": "Timesats",
    "zone": "Generelle satser"
  },
  {
    "pricefield": "Timesats",
    "zone": "Generell"
  },
  {
    "pricefield": "Timer",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Timer",
    "zone": "Stue"
  },
  {
    "pricefield": "Timer",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Timer",
    "zone": "Generelt "
  },
  {
    "pricefield": "Timer",
    "zone": "Gang"
  },
  {
    "pricefield": "Timer",
    "zone": "Entre"
  },
  {
    "pricefield": "Timer",
    "zone": "Bad"
  },
  {
    "pricefield": "Timeforbruk normal bad",
    "zone": "Timer"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Stue"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Soverom"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Kontor"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Gang"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Bryter"
  },
  {
    "pricefield": "Tillegg for svart utførelse ",
    "zone": "Baderom"
  },
  {
    "pricefield": "Tillegg for svart utførelse",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Tilkobling servant u/ deler",
    "zone": "Bad"
  },
  {
    "pricefield": "Tilkobling persienne",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Tilkobling oppvaskmaskin komplett",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Tilkobling oppvaskmaskin enkel",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Tilkobling kjøkkenbenk u/ deler",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Tilkobling jordskinne og etablere jord i soverom og stue",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Tilkobling CU - rør i rør",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Tilkobling baderomsinnredning",
    "zone": "Lys"
  },
  {
    "pricefield": "Tilkobling baderomsinnredning",
    "zone": "Baderom"
  },
  {
    "pricefield": "Tilkobling av servant med deler",
    "zone": "Bad"
  },
  {
    "pricefield": "Termostat mtc3",
    "zone": "Skjult installasjon"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Varme"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Stue"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Soverom"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Kontor"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Generell"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Gang"
  },
  {
    "pricefield": "Termostat digital Elko plus ",
    "zone": "Baderom"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Varme"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Stue"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Soverom"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Garasje"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Gang"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Bod"
  },
  {
    "pricefield": "Termonetting for varmekabel (kvm)",
    "zone": "Baderom"
  },
  {
    "pricefield": "Termonetting (per kvm)",
    "zone": "Varme"
  },
  {
    "pricefield": "Tegning ut over 150 kvm BRA + pr. m2 BRA",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Tegning av nytt påbygg inntil 150 kvm",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Tece vegg ramme med sealbag",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Takpunkt inkl Q-light Donut",
    "zone": "Skjult installasjon"
  },
  {
    "pricefield": "Takpunkt (eks armatur)",
    "zone": "Lys"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Stue"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Soverom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Lys"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Kontor"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Hems"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Garasje"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Gang"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Bod"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Badstu"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Baderom"
  },
  {
    "pricefield": "Takpunkt",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Stikkontakt til Waterguard",
    "zone": "Elektro"
  },
  {
    "pricefield": "Stikkontakt IP44",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt inne",
    "zone": "Trondheim"
  },
  {
    "pricefield": "Stikkontakt hjørne for montasje under overskap",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Stue"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Soverom"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Kontor"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Garasje"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Gang"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Bod"
  },
  {
    "pricefield": "Stikkontakt for tv 4 veis/6veis",
    "zone": "Baderom"
  },
  {
    "pricefield": "Stikkontakt for trykkvakt",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Stikkontakt for trykkvakt",
    "zone": "Generell"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Stue"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Soverom"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Kontor"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Hems"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Garderobe"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Gang"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Bod"
  },
  {
    "pricefield": "Stikkontakt flat 1,5 ",
    "zone": "Baderom"
  },
  {
    "pricefield": "Stikkontakt flat 1,5",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt ferdig montert",
    "zone": "Skjult installasjon"
  },
  {
    "pricefield": "Stikkontakt 4/6 veis",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Stue"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Stikk"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Soverom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Kontor"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Hems"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Garderobe"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Garasje"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Gang"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Bod"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Badstu"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Baderom"
  },
  {
    "pricefield": "Stikkontakt (normal)",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Stikkontakt ",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Stikkontakt ",
    "zone": "Baderom"
  },
  {
    "pricefield": "Stikk elko ",
    "zone": "Bad "
  },
  {
    "pricefield": "Stikk"
  },
  {
    "pricefield": "Standard utvendig armatur",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Standard utvendig armatur",
    "zone": "Lys"
  },
  {
    "pricefield": "Standard TV uttak (cat5/coax)",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Standard TV uttak (cat5/coax)",
    "zone": "Stue"
  },
  {
    "pricefield": "Standard TV uttak (cat5/coax)",
    "zone": "Soverom"
  },
  {
    "pricefield": "Standard TV uttak (cat5/coax)",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Standard TV uttak (cat5/coax)",
    "zone": "Kontor"
  },
  {
    "pricefield": "Standard timer.",
    "zone": "Timer"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Varme"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Stue"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Soverom"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Kontor"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Gang"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Bod"
  },
  {
    "pricefield": "Standard termostat",
    "zone": "Baderom"
  },
  {
    "pricefield": "Standard stikkontakt",
    "zone": "Stikk"
  },
  {
    "pricefield": "Standard speilarmatur",
    "zone": "Lys"
  },
  {
    "pricefield": "Standard speilarmatur",
    "zone": "Baderom"
  },
  {
    "pricefield": "Standard led ufo m/sensor",
    "zone": "Lys"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Stue"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Soverom"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Lys"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Kontor"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Hems"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Garderobe"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Garasje"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Gang"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Bod"
  },
  {
    "pricefield": "Standard led ufo",
    "zone": "Baderom"
  },
  {
    "pricefield": "Standard led downlight",
    "zone": "Lys"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Stue"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Soverom"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Kontor"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Garasje"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Gang"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Bryter"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Bod"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Badstu"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Baderom"
  },
  {
    "pricefield": "Standard led dimmer",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Standard downlight warmdim",
    "zone": "Lys"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Trapperom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Stue"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Soverom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Lys"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Kontor"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Hems"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Garderobe"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Garasje"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Gang"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Bod"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Badstu"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Baderom"
  },
  {
    "pricefield": "standard downlight led",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Standar Bad inntill 8 m2 ",
    "zone": "Bad"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Stue"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Soverom"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Lys"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Gang"
  },
  {
    "pricefield": "Spotskinne 1m med 3 spotter",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Varme"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Stue"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Soverom"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Kontor"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Bryter"
  },
  {
    "pricefield": "Smarthus termostat",
    "zone": "Baderom"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Stue"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Soverom"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Kontor"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Gang"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Bryter"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Bod"
  },
  {
    "pricefield": "Smarthus roterende dimmer",
    "zone": "Baderom"
  },
  {
    "pricefield": "Smarthus gateway",
    "zone": "Varme"
  },
  {
    "pricefield": "Smarthus gateway",
    "zone": "Lys"
  },
  {
    "pricefield": "Smarthus gateway",
    "zone": "Generell"
  },
  {
    "pricefield": "Smarthus gateway",
    "zone": "Bryter"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Stue"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Soverom"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Kontor"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Garderobe"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Garasje"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Gang"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Bryter"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Baderom"
  },
  {
    "pricefield": "Smarthus bryter/dimmer",
    "zone": "Bad"
  },
  {
    "pricefield": "Sluttdokumentasjon",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "slutt kontroll/dokumentasjon bolig",
    "zone": "Generelt "
  },
  {
    "pricefield": "Skifte ut skadet isolasjon",
    "zone": "Bunnledning"
  },
  {
    "pricefield": "Sikringsskap m/måleplass ",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Sikringsskap m/måleplass",
    "zone": "Sikringsskap"
  },
  {
    "pricefield": "Servise Dokumentasjon ",
    "zone": "Servise "
  },
  {
    "pricefield": "Servicebil sone 2",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Servicebil sone 1",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Servantbatteri billig",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Samleskinner og koblingsmateriell",
    "zone": "Fordelinger"
  },
  {
    "pricefield": "Rydding av boder",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Ruth albue 22x18",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Roth veggboks QuickBox ",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth stengeventil 15-18-22",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Roth Quick fordelerskap 400",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth nippel 1/2\" x 3/4\"",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth fordelerskap 8+7 m/fordelere og tilbehør",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth fordelerskap 5+4 m/fordelere og tilbehør",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth fordelerskap 13+12 m/fordelere og tilbehør",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth dør og ramme til fordelerskap MultiPex Quick",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth 25mm pex klammer",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Roth 1/2\" x 10mm m/ avst",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Rørlegger pr time",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Rørlegger",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Rørklammer m/dempegummi ELZINK M8-10 108-114 mm",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Rør-i-rør opplegg inkl fordelerskap og 8 punkter i sokkelleilighet. ",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Rør i rør pr meter 15mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Rør i rør 18mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Rør i rør 12mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Rock spotskinne 1m med 3 spotter",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Rock spotskinne 1m med 3 spotter",
    "zone": "Soverom"
  },
  {
    "pricefield": "Riving/tilpassing av eksisterende anlegg",
    "zone": "Generell"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Stue"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Soverom"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Garasje"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Gang"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Bod"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Baderom"
  },
  {
    "pricefield": "Riving/demontering av utstyr per punkt",
    "zone": "Bad"
  },
  {
    "pricefield": "Ringjord inntil 40m",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Ringeanlegg",
    "zone": "Generell"
  },
  {
    "pricefield": "Ringeanlegg",
    "zone": "Gang"
  },
  {
    "pricefield": "Rigg prosjekt",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Rettnippel 1/2x3/4 (dusj)",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Rettnippel 1/2",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Rehab innsats ferdig montert",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Reflektorovn",
    "zone": "Baderom"
  },
  {
    "pricefield": "Re.h standar Utebelysning ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Stue"
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Servise "
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Generelt "
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Gang"
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Entre"
  },
  {
    "pricefield": "Re.h Sikring 1fas kombivern 10-25A",
    "zone": "Bad"
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Stue"
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Gang"
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Entre"
  },
  {
    "pricefield": "Re.h Nytt punkt til eksisterende anlegg ",
    "zone": "Bad"
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Stue"
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Gang"
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Entre"
  },
  {
    "pricefield": "Re.h Ny  kurs/utskillelse ",
    "zone": "Bad"
  },
  {
    "pricefield": "Rammesøknad",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Qlight Eyeball",
    "zone": "Belysning"
  },
  {
    "pricefield": "Punkt vifte ",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt ventilator",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt varmeovn inntil 1000W",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt Varmekabel ",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt Varmekabel ",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt varmefolie gulv",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt vannutkaster",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Punkt utvendig dobbel stikk"
  },
  {
    "pricefield": "Punkt utslagsvask",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "Punkt TV/media",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt TV/media",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt TV/media",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt termostat m/nattsenking",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt stikk m/USB",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt stikk m/USB",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt stekeovn 16 A",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Generelt "
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt Standard taklampe",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt Standard kjøkken inst 1.Platetopp 2. Ovn 3.Oppvaskmaskin 4.Mikro, ventilator, kjøl/frys 5.Forbruker kurs",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt spotskinne med 3 spotter ",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt spotskinne 2 meter uten spotter",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt sikr. rehab  -> 12k",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt platetopp 25A m/komf.v",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt overspenningsvern ",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt oppvaskmaskin",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt nytt inntak",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt ny kurs 16A inntil 10 m",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt nek399 dobbel ",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt microbølgeovn",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Service "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt lys tak/vegg",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt lys o/speil",
    "zone": "Service "
  },
  {
    "pricefield": "Punkt lys o/speil",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt kurssikring 10-40A 3-pol",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt kurssikring 10-25A 2-pol",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt kursopplegg utelys",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Punkt kjøleskap",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt inntakskabel 4G16",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt hovedsikring OV",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt hovedjording/jordspyd",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt for utelys",
    "zone": "Lys"
  },
  {
    "pricefield": "Punkt for utebelysning",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Punkt for utebelysning",
    "zone": "Lys"
  },
  {
    "pricefield": "Punkt for speilbelysning",
    "zone": "Lys"
  },
  {
    "pricefield": "Punkt for speil eks armatur",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Service "
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt enkel stikk",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt ekstra spot for spotskinne ",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt downlight LED ",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Bod"
  },
  {
    "pricefield": "Punkt dobbel stikk",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt dimmer LED",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt data kat 6 enkel",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt data kat 6 enkel",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt data kat 6 enkel",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt bryter",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Vaskerom "
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Kjeller "
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Hall"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Generelt "
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Gang"
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Entré "
  },
  {
    "pricefield": "Punkt bevegelsesensor",
    "zone": "Bad"
  },
  {
    "pricefield": "Punkt benklys eks. armatur",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt astrour/fotocelle",
    "zone": "Generelt "
  },
  {
    "pricefield": "Punkt astrour/fotocelle",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt ASD avdekking",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Punkt aquastop",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt annen hvitevare",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Punkt 6 veis stikk bak TV",
    "zone": "Stue"
  },
  {
    "pricefield": "Punkt 6 veis stikk bak TV",
    "zone": "Soverom "
  },
  {
    "pricefield": "Punkt 32A kurs med stikk inntill 10 meter",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Punkt 32A kurs med stikk inntill 10 meter",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Pungt nek399 enkel",
    "zone": "fordeling inntak jord  "
  },
  {
    "pricefield": "Prisen er med forbehold om ledig kapasitet i eksisterende kurs",
    "zone": "Varme"
  },
  {
    "pricefield": "PP rør 110mm pr meter",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "PN 6mm (Radon Ex) 40A  per meter (2 leder)",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "PN 2,5mm (Radon Ex) 16a per meter (2 leder)",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Plugg fordeler",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Parkering",
    "zone": "Generell"
  },
  {
    "pricefield": "Papilion Dusjkabinett 90x90",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Panelovn 900w wifi",
    "zone": "Varme"
  },
  {
    "pricefield": "Panelovn 600-800w",
    "zone": "Soverom"
  },
  {
    "pricefield": "Panelovn 600-800w",
    "zone": "Garasje"
  },
  {
    "pricefield": "Panelovn 1000w glassfront",
    "zone": "Varme"
  },
  {
    "pricefield": "Panelovn 1000w",
    "zone": "Varme"
  },
  {
    "pricefield": "Overspenningsvern",
    "zone": "Sikringsskap"
  },
  {
    "pricefield": "Overspenningsvern",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Overbelastningsvern",
    "zone": "Sikringsskap"
  },
  {
    "pricefield": "Overbelastningsvern",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "OSO saga 200 BRL",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "OSO Saga 200",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "OSO 120 flexi BRL",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "OSO 120 Flex benkebereder",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Oras Saga servantkran",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "Oras Safira Kjøkkenbatteri m/avstengning",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "Oras dusjsett",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Oras dusjbatteri",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Orange servantbatteri",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Orange kjøkkenkran m/avstg",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Oramix dusjbatteri",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "Oppmøte/servicebil",
    "zone": "Generell"
  },
  {
    "pricefield": "Oppmøte servicebil",
    "zone": "Generelt"
  },
  {
    "pricefield": "oppmøte service bil",
    "zone": "Generelt "
  },
  {
    "pricefield": "Oppmøte",
    "zone": "Servise "
  },
  {
    "pricefield": "Oppmøte",
    "zone": "Generelt "
  },
  {
    "pricefield": "Opplegg vaskemaskin",
    "zone": "Bad"
  },
  {
    "pricefield": "Opplegg støydempende pr meter",
    "zone": "Bad"
  },
  {
    "pricefield": "Opplegg av vann og avløp til 1etg tiltenkt wc-rom / lite bad i gangen",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Omtrekking av eksisterende punkt",
    "zone": "Generell"
  },
  {
    "pricefield": "Omtrekking av eksisterende kurs",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Omtrekking av eksisterende kurs",
    "zone": "Generell"
  },
  {
    "pricefield": "Omtrekking av eksisterende anlegg",
    "zone": "Soverom"
  },
  {
    "pricefield": "Omlegging av servanter åpent på vegg",
    "zone": "Bad"
  },
  {
    "pricefield": "Ombygging og omtrekking av tilførsel for kjøkken",
    "zone": "Soverom"
  },
  {
    "pricefield": "O-novo veggskål med sete",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Ny sikringslist i k-kasse",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Stue"
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Generelt "
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Gang"
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Entre"
  },
  {
    "pricefield": "Ny Punkt stikk bryter",
    "zone": "Bad"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Stue"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Soverom"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Garasje"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Gang"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Bod"
  },
  {
    "pricefield": "Ny kurs 10/15/16A inntil 15m eks stikk ink sikring",
    "zone": "Baderom"
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Stue"
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Generelt "
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Gang"
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Entre"
  },
  {
    "pricefield": "Ny kurs 10-25 nytt anlegg ",
    "zone": "Bad"
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Stue"
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Generelt "
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Gang"
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Entre"
  },
  {
    "pricefield": "Ny dokumentasjon ",
    "zone": "Bad"
  },
  {
    "pricefield": "Nordesign STP 100 2W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Micenas 5,5W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Micenas 2W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Micenas 20W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Micenas 1,5W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Mey 3W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Gea Effect 2.2W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Basic 1.5W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nordesign Atlantic 3W",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Nek 399 Enkel ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Nek 399 dobbel ",
    "zone": "Utvendig "
  },
  {
    "pricefield": "Multidetektor for Elotec",
    "zone": "Generell"
  },
  {
    "pricefield": "Montering varmtvannstank standar utskifting",
    "zone": "Timer"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Stue"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Soverom"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Lys"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Kontor"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Generell"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Garasje"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Gang"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Bod"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Badstu"
  },
  {
    "pricefield": "Montering takarmatur",
    "zone": "Baderom"
  },
  {
    "pricefield": "Montering av lysarmatur levert av kunde",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Montering av lysarmatur levert av kunde",
    "zone": "Stue"
  },
  {
    "pricefield": "Montering av lysarmatur levert av kunde",
    "zone": "Soverom"
  },
  {
    "pricefield": "Montering av lysarmatur levert av kunde",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Montering av lysarmatur levert av kunde",
    "zone": "Baderom"
  },
  {
    "pricefield": "Montering av dusjkabinett / dusjdører",
    "zone": "Bad"
  },
  {
    "pricefield": "Montering av downligh utvendig levert av kunde",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Montering av bereder levert av kunde",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Montere avdekning i eksisterende fordelinh"
  },
  {
    "pricefield": "Montere avdekning 7 eksisterende fordeling",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Meta med sensor",
    "zone": "Lys"
  },
  {
    "pricefield": "Måler sløyfe utbytte",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Lysarmatur IP 65 Type Storm 2x30watt LED",
    "zone": "Garasje"
  },
  {
    "pricefield": "Lys i gang på eksisterende",
    "zone": "Trondheim"
  },
  {
    "pricefield": "Lift leie per dag",
    "zone": "Generell"
  },
  {
    "pricefield": "Levering og montering av standard kjøkkenventilator m/motor",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Ledstripe benkebelysning 5m",
    "zone": "Lys"
  },
  {
    "pricefield": "Ledstripe benkebelysning 5m",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Ledstripe benkebelysning 5m",
    "zone": "Baderom"
  },
  {
    "pricefield": "Led ufo med sensor",
    "zone": "Lys"
  },
  {
    "pricefield": "Led ufo med sensor",
    "zone": "Gang"
  },
  {
    "pricefield": "Led ufo med bevegelse",
    "zone": "Baderom"
  },
  {
    "pricefield": "Led stripe fra ipas (5m) med alu profil",
    "zone": "Lys"
  },
  {
    "pricefield": "Led strip benkbelysning inntil 5m",
    "zone": "Lys"
  },
  {
    "pricefield": "Led lys himling 60x60 (ikke dimbar)",
    "zone": "Lys"
  },
  {
    "pricefield": "Led lys himling 60x60 (dimbar)",
    "zone": "Lys"
  },
  {
    "pricefield": "Led downlight",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Led downlight",
    "zone": "Baderom"
  },
  {
    "pricefield": "Lastbryter 0-63A",
    "zone": "Fordelinger"
  },
  {
    "pricefield": "Kursfortegnelse og dokumentasjon",
    "zone": "Fordelinger"
  },
  {
    "pricefield": "Kurs for platetopp 20/25A (eks komfyrvakt)",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Kurs for platetopp 20/25A (eks komfyrvakt)",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Kontaktor styring for varme",
    "zone": "Varme"
  },
  {
    "pricefield": "Komfyrvakt 3 faset 25A",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Komfyrvakt ",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Komfyrvakt",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Komfyrvakt",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Koblingspunkt med koblingsboks",
    "zone": "Generell"
  },
  {
    "pricefield": "Klosettsete ",
    "zone": "Bad"
  },
  {
    "pricefield": "Klammer PP 110 sort",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Klammer og festemidler pr bad",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Kjøre/reise",
    "zone": "Timer"
  },
  {
    "pricefield": "Kjøre reise normalt bad",
    "zone": "Timer"
  },
  {
    "pricefield": "Kjøkkenkran billig variant m/avsteg",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Kanal pr.m",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Kanal pr.m",
    "zone": "Garasje"
  },
  {
    "pricefield": "K-sluk 75mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "K-sluk 50mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Jordingsmuffe Ola Stubben",
    "zone": "Bunnledning"
  },
  {
    "pricefield": "Jordfeilautomat 10-25A inkl avdekkinger",
    "zone": "Fordelinger"
  },
  {
    "pricefield": "Jordfeilautomat (rehab) 10/15/16/20/25A",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Jordelektrode",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Internmåler",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Innmelding til e-verk",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Innmelding til e-verk",
    "zone": "Generell"
  },
  {
    "pricefield": "Innkapping avløp PVC pr stk",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Husbrannslange",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Hovedkabel til garasje per meter",
    "zone": "Garasje"
  },
  {
    "pricefield": "Hovedkabel per m(inntil pfxp 4g16)",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Hjelpemann",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Heatit Z-Water (10 soner per enhet) (ink montering og i driftsettelse)",
    "zone": "Varme"
  },
  {
    "pricefield": "GUB utslagsvask",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Gren PP 110 x 110 x 88 Wafix",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Gjengestag/slaganker/monteringsplate/kombiskrue pris pr klammer",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Geberith Duofix Sigma TEK",
    "zone": "Bad"
  },
  {
    "pricefield": "Geberit Duofix",
    "zone": "Bad"
  },
  {
    "pricefield": "Framlegg av kabel til persienne",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Fotocelle",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Fotocelle",
    "zone": "Bryter"
  },
  {
    "pricefield": "Forhøyningsring 13-25-34",
    "zone": "Avløp"
  },
  {
    "pricefield": "Fordeling med svakstrømsfelt",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Fordeling 3 rader u/måleplass",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Fordelerskap 80x55",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordelerskap 55x55",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordelerskap 40x55",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 3x15mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 2x2 15mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 2x15mm",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 1x15",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 18mmx1",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Fordeler 12mx1",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Forbruksmateriell",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "FM Mattsson frostfri utekran 600 mm",
    "zone": "Teknisk VVS"
  },
  {
    "pricefield": "Flytting av VVB inkl materiell",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Flytting av eksisterende kurs",
    "zone": "Generell"
  },
  {
    "pricefield": "Fjern tele uttak",
    "zone": "Gang"
  },
  {
    "pricefield": "Festemateriell",
    "zone": "Generell"
  },
  {
    "pricefield": "FDV Dokumentasjon",
    "zone": "Faste kostnader"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Generell"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Bryter"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Bod"
  },
  {
    "pricefield": "Fast tilkobling av VVB med sikkerhetsbryter",
    "zone": "Baderom"
  },
  {
    "pricefield": "Fast pris Standard kjøkken 4M benk",
    "zone": "Kjøkken "
  },
  {
    "pricefield": "Fagarbeider",
    "zone": "Generelt "
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Stue"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Gang"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Bod"
  },
  {
    "pricefield": "Enøk E27 LED",
    "zone": "Baderom"
  },
  {
    "pricefield": "Enkel Nek 399 sikringsskap",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Elektrisk tilkobling av VVB",
    "zone": "Elektro"
  },
  {
    "pricefield": "Easee home inntil 15 kabel",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Easee elbil lader ferdig montert inntil 15m",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Easee elbil lader ferdig montert inntil 15m",
    "zone": "Generell"
  },
  {
    "pricefield": "Dusjsett billig ",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Dusjbatteri azur billig",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Durgo 110mm",
    "zone": "Teknisk VVS"
  },
  {
    "pricefield": "Downlights ",
    "zone": "Bad "
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Stue"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Soverom"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Lys"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Garasje"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Gang"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Bod"
  },
  {
    "pricefield": "Downlight led warmdim",
    "zone": "Baderom"
  },
  {
    "pricefield": "Downlight for utvendig montasje",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Downlight for utvendig montasje",
    "zone": "Lys"
  },
  {
    "pricefield": "Dør fordelerskap 800",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Dør fordelerskap 55",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Dør fordelerskap 400",
    "zone": "Bad skjult "
  },
  {
    "pricefield": "Dokumentasjon",
    "zone": "Generelt"
  },
  {
    "pricefield": "Dokumentasjon",
    "zone": "Generell"
  },
  {
    "pricefield": "Dobbelmuffe PP 110 mm Wafix",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Dobbel Nek 399 tilknytningsskap",
    "zone": "Sikringskap"
  },
  {
    "pricefield": "Dobbel Nek 399 tilknytningsskap",
    "zone": "Generell"
  },
  {
    "pricefield": "Dobbel dimmer for led",
    "zone": "Stue"
  },
  {
    "pricefield": "Dispensasjonssøknad",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Dimmer",
    "zone": "Skjult installasjon"
  },
  {
    "pricefield": "Demontering av utstyr (stikk/lys)",
    "zone": "Garasje"
  },
  {
    "pricefield": "Demontering av trefaset utstyr",
    "zone": "Garasje"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Stue"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Soverom"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Garasje"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Gang"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Bod"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Baderom"
  },
  {
    "pricefield": "Dekklokk",
    "zone": "Bad"
  },
  {
    "pricefield": "bytte fra bryter til dimmer",
    "zone": "Trondheim"
  },
  {
    "pricefield": "Bunnledning PP 110/75 pr punkt",
    "zone": "Bunnledning"
  },
  {
    "pricefield": "Bunnledning i PP med 6 oppstikk og jordingsmuffe, frem til Soil ved grunmmur. ",
    "zone": "Bunnledning"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Ungdomsavdeling"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Trapperom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Toalett/WC"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Stue"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Soverom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Mediarom/trimrom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Kontor"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Hems"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Garderobe"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Garasje"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Gang"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Bryter"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Bod"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Badstu"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Baderom"
  },
  {
    "pricefield": "Bryterpunkt",
    "zone": "Annet rom"
  },
  {
    "pricefield": "Bryter",
    "zone": "Skjult installasjon"
  },
  {
    "pricefield": "Brannvarslingsanlegg (2 meldere og sentral)",
    "zone": "Generell"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Vaskerom"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Stue"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Soverom"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Garasje"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Gang"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Bod"
  },
  {
    "pricefield": "Brannmelder",
    "zone": "Baderom"
  },
  {
    "pricefield": "Brannalarmsentral Elotec Ajax",
    "zone": "Generell"
  },
  {
    "pricefield": "Blandeventil OSO",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Betjeningsplate sigma",
    "zone": "Bad"
  },
  {
    "pricefield": "Berederslanger",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Benkearmatur LED med stikk og bryter",
    "zone": "Lys"
  },
  {
    "pricefield": "Benkearmatur LED med stikk og bryter",
    "zone": "Kjøkken"
  },
  {
    "pricefield": "Bend PP 110 x 88° Wafix",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": "Belysning P-kjeller",
    "zone": "Disponibelt"
  },
  {
    "pricefield": "BD gjennomføring for dusjkabinett 1/2\" x 3/4\"",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Badstue ovn (inntil 5kvm) (inkl ny kurs)",
    "zone": "Badstu"
  },
  {
    "pricefield": "Avløp til sikkerhetsventil VVB",
    "zone": "Varmtvannsbereder"
  },
  {
    "pricefield": "Astro ur (tidsstyring for utelys)",
    "zone": "Utvendig"
  },
  {
    "pricefield": "Astro ur (tidsstyring for utelys)",
    "zone": "Støttemur"
  },
  {
    "pricefield": "Astro ur (tidsstyring for utelys)",
    "zone": "Bryter"
  },
  {
    "pricefield": "Ansvar arkitektur",
    "zone": "Vare/tjeneste"
  },
  {
    "pricefield": "Alterna Click 90x90 komplett m/blandebatteri",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Alterna Click 6310543 Frontpakke\t90 x 90 x 200",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Alterna 6310542\tBakvegger 90 x 90 x 200",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Alterna 6310541\tDusjkar\t90 x 90 x 200",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Alterna 2.0 termostatbatteri for dusj",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "Albu 1/2x10mm (servant)",
    "zone": "Bad synlig utstyr"
  },
  {
    "pricefield": "Ahlsell Komplett servant innredning m/ høyskap",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "Ahlsell komplett servant innredning",
    "zone": "Sanitærutstyr"
  },
  {
    "pricefield": "A-Collection servantbatteri uten servantventil",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "A-collection Azur Dusjbatteri",
    "zone": "Blandebatteri"
  },
  {
    "pricefield": "75mm plastsluk u/anborring",
    "zone": "Bad"
  },
  {
    "pricefield": "75mm avløpsrør",
    "zone": "Avløp"
  },
  {
    "pricefield": "70mm 45 g bend",
    "zone": "Avløp"
  },
  {
    "pricefield": "50mm vegguttak",
    "zone": "Avløp"
  },
  {
    "pricefield": "50mm nippet muffe",
    "zone": "Avløp"
  },
  {
    "pricefield": "50mm avløps rør",
    "zone": "Avløp"
  },
  {
    "pricefield": "50mm 45g bend",
    "zone": "Avløp"
  },
  {
    "pricefield": "40mm vegg uttak ",
    "zone": "Avløp"
  },
  {
    "pricefield": "40mm nippet muffe",
    "zone": "Avløp"
  },
  {
    "pricefield": "40mm avløps rør",
    "zone": "Avløp"
  },
  {
    "pricefield": "40mm 45g bend"
  },
  {
    "pricefield": "32mm vanninnlegg pr meter",
    "zone": "Utvendig"
  },
  {
    "pricefield": "3/4 reduksjonsventil",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "25mm klammer betong for RIR",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "250 ECO høiax",
    "zone": "Varmtvannstanker"
  },
  {
    "pricefield": "200 l med exspan",
    "zone": "Varmtvannstanker"
  },
  {
    "pricefield": "200 ECO høiax",
    "zone": "Varmtvannstanker"
  },
  {
    "pricefield": "15mm Roth PEX",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": "120 l benkbreder høiax ",
    "zone": "Varmtvannstanker"
  },
  {
    "pricefield": "110x110x45g",
    "zone": "Avløp"
  },
  {
    "pricefield": "110mm avløps rør",
    "zone": "Avløp"
  },
  {
    "pricefield": "110mm 90g bend",
    "zone": "Avløp"
  },
  {
    "pricefield": "1\" vanninntak etter TEK17 u/ekspansjon kar",
    "zone": "Teknisk rom"
  },
  {
    "pricefield": "001"
  },
  {
    "pricefield": " Roth VUK skap for vannutkaster",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt WC",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt VVB",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt vaskemaskin",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt servant",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt Kjøkken",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Punkt Dusjbatteri",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " Montering av oppvaskmaskin",
    "zone": "Kjøkken"
  },
  {
    "pricefield": " Fordelerskap for vannutkaster",
    "zone": "Roth tappevannssystem "
  },
  {
    "pricefield": " 32 mm bakkekrane isiflo",
    "zone": "Utvendig"
  },
  {
    "pricefield": " 15mm kappilarrør m/deler PR METER",
    "zone": "Rørstrekk"
  },
  {
    "pricefield": " 12mm kappilarrør m/deler PER METER",
    "zone": "Rørstrekk"
  }
]

export const priceFields: {
  [zone: string]: string[]
} = original.reduce((acc, { pricefield: priceField, zone }) => {
  if (!zone) {
    return acc
  }
  //@ts-ignore
  const existing = acc[zone] || []
  return ({
    ...acc,
    [zone]: [...existing, priceField],
  })
}, {})

export const priceFieldZones: {
  [priceField: string]: string[]
} = original.reduce((acc, { pricefield: priceField, zone }) => {
  if (!priceField) {
    return acc
  }
  //@ts-ignore
  const existing = acc[priceField] || []
  return ({
    ...acc,
    [priceField]: [...existing, zone],
  })
}, {})
